module.exports = __webpack_public_path__ + "img/product_2.6fb4f85.webp";